module.exports = __webpack_public_path__ + "assets/img/26.c7acaedd.png";